import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { Menu, Select } from "@sscs/ui";
const ClassificationFilter = ({ classification, onChange, className, }) => {
    return (React.createElement(Select, { id: "filter-classification", label: "Filter by classification", labelId: "classification-filter-label", value: classification, displayEmpty: true, shrinkLabel: true, onChange: (value) => {
            if (value === "ALL" ||
                SDLCMetadataTypeGuards.stringIsClassification(value)) {
                onChange(value);
            }
        }, className: className },
        React.createElement(Menu.Item, { id: "show-all-classifications", value: "ALL" }, "Show all classifications"),
        React.createElement(Menu.Item, { id: "filtered-by-malicious", value: "Malicious" }, "Malicious"),
        React.createElement(Menu.Item, { id: "filtered-by-suspicious", value: "Suspicious" }, "Suspicious"),
        React.createElement(Menu.Item, { id: "filtered-by-goodware", value: "Goodware" }, "Goodware"),
        React.createElement(Menu.Item, { id: "filtered-by-unknown", value: "Unknown" }, "Unknown")));
};
export default ClassificationFilter;
//# sourceMappingURL=ClassificationFilter.js.map